export const SITUACAO_REAGENDADA_CODIGO = 1;

export const SITUACAO_REAGENDADA_LABEL = "Reagendada";
